// extracted by mini-css-extract-plugin
export default {"root":"Search_root__vLFg3","input":"Search_input__Q5ahD","searchBtn":"Search_searchBtn__HTVKP"};